module.exports = {
      id: "eid-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#eid",
      toString: function () {
        return this.url;
      }
    }